import React from 'react';

import BigBreadcrumbs from '../layout/navigation/components/BigBreadcrumbs.jsx'
import WidgetGrid from '../layout/widgets/WidgetGrid.jsx'

import FirbaseTest from './FirbaseTest'
import PushSender from './PushSender'

export default class NotificationRoot extends React.Component{

  render(){

    let pushNotificationUrl = this.props.pushNotificationUrl;
    let notificationCount = this.props.notificationCount;
    let isDev = this.props.isDev;
    let maxBodyLength = 700;

    let testForm;

    if (isDev === '1' ) {

      testForm = <FirbaseTest fcmUrl={this.props.fcmUrl} ></FirbaseTest>;
    }

    return <div id="content">
      <div className="row">
        <BigBreadcrumbs items={['Forms', 'Form Elements']} icon="table" className="col-xs-12 col-sm-7 col-md-7 col-lg-4" />
      </div>

      {/* widget grid */}
      <WidgetGrid>

        {/* NEW COL START */}
        <article className="col-sm-12 col-md-12 col-lg-12">

          <PushSender isDev={isDev} pushNotificationUrl={pushNotificationUrl} maxBodyLength={maxBodyLength} notificationCount={notificationCount}></PushSender>

          {testForm}

        </article>
      </WidgetGrid>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/notification/NotificationRoot.js